import { useEffect } from 'react'

/** 可视分集区块进入视口时触发懒加载 */
export function useLazyScriptEpisodeObserver(
  rootRef: React.RefObject<HTMLElement | null>,
  enabled: boolean,
  episodeNos: number[],
  onEpisodeVisible: (episodeNo: number) => void,
) {
  useEffect(() => {
    const root = rootRef.current
    if (!root || !enabled || episodeNos.length === 0) return

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue
          const raw = entry.target.getAttribute('data-episode-no')
          const ep = raw ? Number.parseInt(raw, 10) : NaN
          if (Number.isFinite(ep) && ep > 0) onEpisodeVisible(ep)
        }
      },
      { root, rootMargin: '240px 0px', threshold: 0 },
    )

    const nodes = root.querySelectorAll('[data-episode-no]')
    nodes.forEach((node) => observer.observe(node))
    return () => observer.disconnect()
  }, [rootRef, enabled, episodeNos, onEpisodeVisible])
}
